import React from 'react';
import { PAYMENT_CONFIG, formatCurrency, formatViews } from '../../lib/paymentConfig';

interface StepTermsProps {
  termsAgreed: boolean;
  onToggle: (checked: boolean) => void;
  onNext: () => void;
}

const StepTerms: React.FC<StepTermsProps> = ({ termsAgreed, onToggle, onNext }) => (
  <div className="max-w-xl mx-auto px-4">
    <div className="bg-white rounded-[2rem] shadow-xl border border-gray-100 overflow-hidden">
      <div className="p-8 space-y-8">
        <div>
          <h3 className="text-xl font-black text-gray-900 mb-6 flex items-center gap-2">
            <span>Payment terms</span>
            <span className="text-xs font-bold bg-gray-100 text-gray-500 px-2 py-1 rounded-md uppercase tracking-wide">Quick Read</span>
          </h3>

          <div className="space-y-6">
            <div>
              <h4 className="font-bold text-gray-900 mb-2 text-sm uppercase tracking-wide">Deliverables</h4>
              <ul className="space-y-2 text-gray-600 text-sm font-medium">
                <li className="flex gap-2">
                  <span className="text-purple-500 font-bold">•</span>
                  20 edited videos per month
                </li>
                <li className="flex gap-2">
                  <span className="text-purple-500 font-bold">•</span>
                  Raw footage for each video (for variations)
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-bold text-gray-900 mb-2 text-sm uppercase tracking-wide">Pay</h4>
              <ul className="space-y-2 text-gray-600 text-sm font-medium">
                <li className="flex gap-2">
                  <span className="text-purple-500 font-bold">•</span>
                  {formatCurrency(PAYMENT_CONFIG.perVideoRate)} per approved video ({formatCurrency(PAYMENT_CONFIG.monthlyBase)}/month at {PAYMENT_CONFIG.videosPerMonth} videos)
                </li>
                <li className="flex gap-2">
                  <span className="text-purple-500 font-bold">•</span>
                  Bonus: {formatCurrency(PAYMENT_CONFIG.cpmRate)} per 1,000 views for videos reaching {formatViews(PAYMENT_CONFIG.viewThreshold)}+ views
                </li>
                <li className="flex gap-2">
                  <span className="text-purple-500 font-bold">•</span>
                  60-day bonus window from date posted (two 30-day periods)
                </li>
                <li className="flex gap-2">
                  <span className="text-purple-500 font-bold">•</span>
                  Bonus cap: {formatCurrency(PAYMENT_CONFIG.maxBonusPerVideo)} per video
                </li>
                <li className="flex gap-2">
                  <span className="text-purple-500 font-bold">•</span>
                  Paid on the first Monday of each month
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-8 p-4 bg-amber-50 rounded-xl border border-amber-100 text-amber-800 text-sm font-medium flex gap-3">
            <span className="text-xl">⚠️</span>
            <p>Note: After you apply, you will receive a video test by email. Completion is required to be considered.</p>
          </div>
        </div>

        <div className="pt-6 border-t border-gray-100 space-y-6">
          <label className="flex items-start gap-3 cursor-pointer group">
            <input
              type="checkbox"
              className="mt-1 h-5 w-5 cursor-pointer rounded-md border-2 border-gray-200 checked:bg-black checked:border-black transition-all"
              checked={termsAgreed}
              onChange={(e) => onToggle(e.target.checked)}
            />
            <span className="text-sm font-medium text-gray-600 group-hover:text-gray-900 transition-colors select-none">
              I understand and accept these terms. <a href="/terms" target="_blank" className="underline text-gray-400 hover:text-gray-900 ml-1">Read full terms</a>
            </span>
          </label>

          <button
            onClick={onNext}
            disabled={!termsAgreed}
            className="w-full py-4 bg-black text-white rounded-xl font-bold hover:bg-purple-700 transition-all disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-black shadow-lg shadow-purple-500/10"
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  </div>
);

export default StepTerms;
